import { createApp, h } from "vue";
import MailOverview from "./components/MailOverview";
import { plugin, defaultConfig } from "@formkit/vue";

const app = createApp({
    render: () =>
        h(MailOverview, {
            value: window.booking ?? null,
            details: window.details ?? null,
            recipients: window.recipients ?? null,
            adminMail: window.adminMail ?? null,
        }),
});

app.use(
    plugin,
    defaultConfig({
        config: {
            classes: {
                input: "form-control",
                wrapper: "form-group",
            },
        },
    })
);

app.mount("#booking-mails");
